<template>
  <div>
    <title>销售方管理</title>
    <TradingRoleInfo :roleType='1'></TradingRoleInfo>
  </div>
</template>
<script>
export default {
  name: 'SellerList',
  data () {
    return {
    }
  },
  components: {
    TradingRoleInfo: resolve => require(["@/components/InvoiceManage/TradingRoleInfo.vue"], resolve),// 购买方/销售方列表组件
  },
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/InvoiceManage/SellerList.vue